import { styled } from '@mui/material';
import theme from '../../theme';

export const TextArea = styled('textarea')({
  width: '100%',
  backgroundColor: theme.palette.secondary.dark,
  border: 'none',
  paddingTop: '12px',
  paddingBottom: '10px',
  paddingLeft: '5px',
  paddingRight: '5px',
  borderRadius: '8px',
  color: 'white',
  fontSize: '13px',
  lineHeight: '100%',
  fontFamily: 'Rubber Duck !important',
  resize: 'none',

  ':disabled': {
    color: 'white',
    opacity: '1 !important',
  },

  '::placeholder': {
    color: 'white',
    whiteSpace: 'nowrap',
  },
});
